import React from 'react';
import './RichText.css';

const RichText = ({ text }) => {
    return (
        <div dangerouslySetInnerHTML={{__html: text.replace(/&nbsp;/g, ' ')}} className={"RichText"}></div>
    );
};

export default RichText;